import React from "react";
import FormInput from "./form-input";
import FormText from "./form-text";
import { validateEmail, validateTel } from "../../utility/formatters";

const FormPerson = ({ labelManagerLabels, mobileRequired, cityRequired }) => {
  return (
    <>
      <FormInput
        id="firstName"
        field="firstName"
        maxLength={40}
        placeholder={`${labelManagerLabels.formName} *`}
        isRequired={true}
      />
      <FormInput
        id="lastName"
        field="lastName"
        maxLength={80}
        placeholder={`${labelManagerLabels.formLastName} *`}
        isRequired={true}
      />
      <FormInput
        id="email"
        field="email"
        type="email"
        maxLength={80}
        placeholder={`${labelManagerLabels.formEmail} *`}
        isRequired={true}
        validate={validateEmail}
        formatWarning={labelManagerLabels.validEmail}
      />
      <FormText
        id="address"
        field="address"
        placeholder={labelManagerLabels.formAddress}
        rows="3"
      />
      <FormInput
        id="city"
        field="city"
        maxLength={40}
        placeholder={`${labelManagerLabels.formCity} ${cityRequired ? "*" : ""}`}
        isRequired={cityRequired}
      />
      <FormInput id="state" field="province" placeholder={labelManagerLabels.formProvince} />
      <FormInput
        id="zip"
        field="zipCode"
        maxLength={20}
        placeholder={`${labelManagerLabels.formZipCode} *`}
        isRequired={true}
      />
      <FormInput
        id="phone"
        field="phone"
        type="tel"
        maxLength={40}
        placeholder={labelManagerLabels.formPhone}
        validate={validateTel}
        formatWarning={labelManagerLabels.validNumber}
      />
      <FormInput
        id="mobile"
        field="mobilePhone"
        type="tel"
        maxLength={40}
        placeholder={`${labelManagerLabels.formMobile} ${mobileRequired ? "*" : ""}`}
        validate={validateTel}
        formatWarning={labelManagerLabels.validNumber}
        isRequired={mobileRequired}
      />
    </>
  );
};

export default FormPerson;
